// extracted by mini-css-extract-plugin
module.exports = {"ModalTabs":"LoginModalBtns_ModalTabs__1s0ac","ModalTabsButton":"LoginModalBtns_ModalTabsButton__Wju63","active":"LoginModalBtns_active__15caf"};